import { Component, Input, OnChanges } from '@angular/core';
import * as moment from 'moment';
import { Finding } from 'src/app/beans/health-summary/health-summary.module.bean';
import { AppUtil } from 'src/app/utils/app.util';

/**
 *
 * loads the charts for the lab results data
 * @export
 * @class LabResultsComponent
 * @implements {OnChanges}
 */
@Component({
	selector: 'app-lab-results',
	templateUrl: './lab-results.component.html',
	styleUrls: ['./lab-results.component.scss'],
})
export class LabResultsComponent implements OnChanges {
	/**
	 * the health metrics used to render the charts
	 */
	@Input() metrics: Finding[];
	/**
	 * Optimization from parent component to avoid rendering too often
	 */
	@Input() renderCharts: boolean;
	appUtil = AppUtil;
	/**
	 *
	 * step variable used in setStep
	 */
	step = 1;
	/**
	 * The chart information to be rendered
	 */
	chartType: any = {};
	/**
	 * Creates an instance of LabResultsComponent.
	 * @memberof LabResultsComponent
	 */
	constructor() { }
	/**
	 * On component initialization
	 * Goes through each metric to pass to chartTypeBuilder
	 */
	ngOnChanges() {
		if (this.metrics) {
			this.metrics.forEach(metric => this.chartTypeBuilder(metric));
		}
	}

	/**
	 *
	 * Takes a health metric and extracts the needed data to render the chart
	 * @param {Finding} metric
	 * @memberof LifestyleComponent
	 */
	chartTypeBuilder(metric: Finding) {
		const attributeValue = metric.value;
		metric.ranges.sort((a, b) => {
			return a.max - b.max;
		});
		const attributeScale = metric.ranges.map(scale => [scale.min, scale.max]);
		let indicatorScale = metric.ranges.filter(scale => scale.indicator === true)[0];
		// FIXME: this is here as a workaround
		// see FITEHEME-612 for more details
		if (indicatorScale === null || indicatorScale === undefined) {
			indicatorScale = metric.ranges[0];
		}
		const pointerColor = indicatorScale.hexValue;
		const attributeDescription = indicatorScale.desc;
		const metricDescription = metric.description;
		const attributeScalesColors = metric.ranges.map(scale => scale.hexValue);
		const attributeUpdatedDate = moment(metric.lastUpdated, 'MM-DD-YYYY').format('MMM D, YYYY');
		const chartName = metric.name;
		const unitOfMeasurement = metric.unitOfMeasurement;
		this.chartType[`${metric.name}`] = {
			attributeDescription,
			attributeScale,
			attributeUpdatedDate,
			attributeValue,
			chartDisplay: 'multiple',
			chartType: 'calculated',
			colors: attributeScalesColors,
			pointerColor,
			chartName,
			metricDescription,
			unitOfMeasurement,
		};
	}

	/**
	 *
	 * potentially unused function
	 * @param {number} index
	 * @memberof LabResultsComponent
	 */
	setStep(index: number) {
		this.step = index;
	}
}
